import { createStore } from 'vuex'

// Import image assets directly
import shopImage from '@/assets/shop.jpg'
import shop1Image from '@/assets/shop1.jpg'

export default createStore({
  state: {
    products: [],
    categories: [
      { id: 2, name: '女装', icon: 'user-circle-o' },
      { id: 3, name: '男装', icon: 'contact' },
      { id: 4, name: '生活装', icon: 'shop-o' },
      { id: 5, name: '婚服', icon: 'like-o' },
      { id: 6, name: '春秋装', icon: 'flower-o' },
      { id: 7, name: '礼服', icon: 'diamond-o' },
      { id: 8, name: '传统袍', icon: 'gem-o' },
      { id: 9, name: '童装', icon: 'smile-o' },
      { id: 10, name: '冬装', icon: 'wap-nav' },
      { id: 11, name: '夏装', icon: 'sunny-o' }
    ]
  },
  mutations: {
    setProducts(state, products) {
      state.products = products
    }
  },
  actions: {
    fetchProducts({ commit }) {
      // 模拟API调用
      const products = [
        {
          id: 1,
          name: '2023 蒙古丽人传统服装',
          price: 6500.00,
          image: shopImage,
          category: '定制款',
          makeTime: '20天'
        },
        {
          id: 2,
          name: '蒙古丽人AB款传统服装',
          price: 10000.00,
          image: shop1Image,
          category: '定制款',
          makeTime: '20天'
        },
        {
          id: 3,
          name: '2023蒙古丽人紫色款',
          price: 6500.00,
          image: shopImage,
          category: '定制款',
          makeTime: '20天'
        },
        {
          id: 4,
          name: '蒙古丽人传统婚服',
          price: 12000.00,
          image: shop1Image,
          category: '定制款',
          makeTime: '20天'
        }
      ]
      commit('setProducts', products)
    }
  },
  modules: {
  }
}) 